import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

export function getNonUmbracoUrl(url?: string) {
  if (!url) {
    return "/"
  }
  if (url?.startsWith("/media/")) {
    return getUmbracoMediaUrl(url)
  }

  let processedUrl: string

  if (url?.includes("pages/home")) {
    processedUrl = url?.includes("en-us") ? "/en" : "/"
  } else if (url?.includes("/shared")) {
    processedUrl = url?.includes("en-us")
      ? "/en" + url?.replace(/.*\/general-information/, "")
      : url?.replace(/.*\/general-information/, "") || "/"
  } else if (!url?.includes("pages")) {
    processedUrl = url
  } else {
    processedUrl = url?.includes("en-us")
      ? "/en" + url?.replace(/.*\/pages/, "")
      : url?.replace(/.*\/pages/, "") || "/"
  }

  // Add UTM parameters to internal links (not media URLs)
  // if (!url?.startsWith("/media/")) {
  //   processedUrl = appendUtmParams(processedUrl)
  // }
  return processedUrl
}
